<template>

</template>
<script>
import axios from 'axios';
import base from '@/clients/base';
import * as Cookies from 'js-cookie';

export default {
  name: 'news-modal',
  props: ['url', 'type'],
  data() {
    return {
      message: '',
      date: '',
      visible: false,
    };
  },
  created() {
    this.getNews();
  },
  methods: {
    getNews() {
      axios.get(`${process.env.VUE_APP_BACKEND}${this.url}`).then(({ data }) => {
        if (this.checkMessage(data.id, data.is_available, data.message)) {
          this.createMessage(data.starts_at.split(' ')[0], data.message, data.id);
        }
      });
    },
    createMessage(date, message, id) {
      this.$emit('create', date, message, id);
    },
    checkMessage(id, available, message) {
      const read = Cookies.get(`mozgoNews${this.type}`);
      let open;
      open = read == id ? false : !!available;
      if (!message.length) {
        open = false;
      }
      return open;
    },

  },

};
</script>
<style scoped>

</style>
